<template>
  <div class="downloader">
    <div
      v-tooltip="tooltipContent"
      class="downloading-progress"
      :style="{ width: `${width}px` }">
      <div
        class="downloading-progress-bar"
        :style="{ width: progressWidth }"
        :data-value="dataValue"
        :data-max="max"></div>
    </div>
    <div
      v-if="showPercentage"
      class="percentage">
      {{ progress }}%
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  interface IProps {
    progress: number;
    max?: number;
    width?: number; // px
    tooltipContent: string;
    showPercentage?: boolean;
  }

  const { progress = 0, max = 100, width = 300, tooltipContent, showPercentage = true } = defineProps<IProps>();

  const dataValue = computed<number>(() => progress / 100);
  const progressWidth = computed<string>(() => {
    if (progress > 100) return '100%';
    return `${progress}%`;
  });
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .downloader {
    display: flex;
    align-items: center;

    .downloading-progress {
      position: relative;
      float: left;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.15);
      padding: 5px;
      box-sizing: border-box;
      border-radius: 10px;
    }

    .downloading-progress-bar {
      position: relative;
      width: 0%;
      height: 10px;
      border-radius: 8px;
      background-color: var(--primaryColor);
    }

    .percentage {
      background-color: var(--primaryColor);
      border-radius: 15px;
      color: var(--primaryColorReverse);
      font-size: 1.25rem;
      margin: 0 0 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.25rem 1rem;
    }
  }
</style>
